const isOnlyNumbers = (text) => {
  const regex = /^[0-9]*$/;

  return regex.test(text);
};

export default isOnlyNumbers;
